import { c as _c } from "react/compiler-runtime";
import React from "react";
import Svg from "../Svg";
const Icon = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.72168 11.1839L10.4114 19L15.101 11.1839C18.1655 6.07647 16.3676 0 10.4114 0C4.45517 0 2.65724 6.07647 5.72168 11.1839Z" fill="black" />;
    t1 = <circle cx="10.412" cy="5.58829" r="2.85294" stroke="white" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <Svg width={21} height={19} viewBox="0 0 21 19" {...props}>{t0}{t1}</Svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default Icon;